// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"37408958","239":"00064a4f","667":"fce3bcbf"}[chunkId] + ".chunk.js";
};